import type { SiteCopy } from './types';

const zh: SiteCopy = {
  meta: {
    title: 'UniteStream · UniteBase & UniteGo',
    description:
      '面向具身智能团队的两大产品：UniteBase 一体化数据底座与 UniteGo 极简第一视角采集，覆盖从数据基建到现场采集的完整链路。',
    keywords:
      'UniteBase,UniteGo,具身智能,数据平台,数据接入,数据集管理,第一视角采集,AI标注,UniteStream',
  },
  nav: {
    products: '产品',
    uniteBase: 'UniteBase',
    uniteGo: 'UniteGo',
    blog: '博客',
    contact: '联系我们',
    languageAria: '界面语言',
  },
  blog: {
    eyebrow: '博客',
    listTitle: '最新文章',
    listSubtitle: '产品更新、技术实践与具身智能行业观察。',
    backToList: '返回博客列表',
  },
  hero: {
    eyebrow: '具身智能 · Embodied AI',
    title: '具身智能',
    titleAccent: '采集 + 数据平台',
    subtitle:
      'UniteGo 用一部 iPhone 完成现场第一视角采集；UniteBase 提供存储、目录与多模态分析一体化的云端数据平台。从录制到大模型训练，为机器人团队贯通端到端工具链。',
    ctaPrimary: '预约演示',
    ctaSecondary: '了解产品',
  },
  products: {
    uniteGo: {
      title: 'UniteGo · 极简数据采集',
      body: '仅需一部 iPhone，零穿戴负担。高清画面与手部 3D 空间轨迹天然帧级同步。',
      cta: '了解 UniteGo →',
    },
    uniteBase: {
      title: 'UniteBase · 一体化数据平台',
      body: '云端一体化数据平台：S3 存储、全局目录、多模态分析，机器人数据随取随用。',
      cta: '了解 UniteBase →',
    },
  },
  homeCta: {
    title: '准备好构建你的具身智能数据管线了吗？',
    subtitle: '抛弃沉重设备与零散脚本，体验最现代化的协作方式。',
    button: '开始使用 UniteStream',
  },
  contact: {
    eyebrow: '联系我们',
    title: '获取 UniteBase / UniteGo 部署方式',
    subtitle: '留下你的联系方式与需求，我们会尽快与你联系，提供适合的部署方案与支持。',
    labels: {
      name: '姓名',
      email: '邮箱',
      company: '公司 / 团队',
      message: '需求说明',
    },
    placeholders: {
      name: '你的称呼',
      email: 'name@company.com',
      company: '公司或团队名称',
      message: '简单描述你的场景、数据规模或部署需求',
    },
    submit: '获取部署方式',
    sending: '提交中…',
    success: '已收到！我们会尽快与您联系。',
    error: '提交失败，请稍后重试。',
    note: '提交即表示同意我们仅将该信息用于与你联系。',
  },
  footer: {
    tagline: '具身智能数据产品',
    product: 'UniteStream',
    privacy: '隐私说明',
    cookies: 'Cookie 设置',
    rights: '保留所有权利。',
  },
  cookie: {
    title: 'Cookie 与本地存储',
    lead: '我们仅使用严格必要的 Cookie 与本地存储，用于记住语言偏好及您的确认记录。本站不使用访问统计或第三方追踪。',
    acknowledge: '知道了',
    learnMore: '隐私说明',
    settingsTitle: 'Cookie 设置',
    inventoryTitle: '本站点使用的存储项',
    inventory: [
      {
        name: 'unitestream-cookie-consent',
        purpose: '保存您已阅读 Cookie 说明的记录',
        duration: '12 个月',
        type: '严格必要（localStorage）',
      },
      {
        name: 'URL 参数 lang',
        purpose: '记住您选择的界面语言（中/英）',
        duration: '会话 / 直至您更改',
        type: '严格必要',
      },
    ],
  },
  privacy: {
    close: '知道了',
    sections: [
      {
        title: '适用范围',
        body: '本说明适用于 UniteStream 官方网站（含 UniteBase、UniteGo 产品介绍页、博客及联系表单）。产品控制台内的账号与数据处理，以其各自服务条款与隐私政策为准。',
      },
      {
        title: '我们收集的信息',
        body: '当您提交联系表单时，我们可能收集姓名、邮箱、公司/团队名称及需求说明。为记住您的语言偏好，我们使用严格必要的本地存储。',
      },
      {
        title: '信息如何使用与法律依据',
        body: '联系信息用于回复咨询与商务沟通（GDPR：合同前措施 / 合法利益）。我们不会出售个人信息。向处理器或法律要求的披露除外，未经同意不向无关第三方共享。',
      },
      {
        title: 'Cookie 与本地存储',
        body: '本站仅使用严格必要的 Cookie 与本地存储（语言偏好、Cookie 说明确认记录）。我们不使用访问统计、广告或第三方追踪技术。',
      },
      {
        title: '保存期限与您的权利',
        body: '联系信息在商务沟通所需期限内保留。您享有访问、更正、删除、限制处理、数据可携及反对处理等权利（GDPR 第 15–22 条），并有权向监管机构投诉。请通过联系表单行使权利。',
      },
      {
        title: '国际访问与说明更新',
        body: '网站面向全球访问。若您位于欧洲经济区、英国或其他适用地区，上述权利与义务对您同样适用。我们可能更新本说明；重大变更将在网站提示，更新后继续使用即视为已阅读新版说明。',
      },
    ],
  },
};

export default zh;
